<template>
  <section>
    <div class="task-title">{{ task.title }}</div>
    <p class="task-description">{{ task.description }}</p>

    <div class="row py-1">
      <div class="col">
        <div class="d-flex task-company-name">{{ task.company.name }}</div>
      </div>
      <div class="col text-right">
        <p class="task-creation-date">
          Posted
          {{ timeFormatter.displayFullDateTime(new Date(task.created_at)) }}
        </p>
      </div>
    </div>

    <div class="row py-3">
      <div class="col col-md-4 mb-3">
        <table>
          <tr>
            <th>Due</th>
          </tr>
          <tr>
            <td>{{ estimatedTaskCompletionDate }}</td>
          </tr>
        </table>
      </div>
      <div class="col col-md-8 mb-3">
        <table>
          <tr>
            <th>Hours Est.</th>
          </tr>
          <tr>
            <td>{{ estimatedTaskHour }}</td>
          </tr>
        </table>
      </div>
      <div class="col col-md-4">
        <table>
          <tr>
            <th>Pay</th>
          </tr>
          <tr>
            <td>{{ estimatedCost }}</td>
          </tr>
        </table>
      </div>
      <div class="col col-md-8">
        <table>
          <tr>
            <th>Sub-tasks</th>
          </tr>
          <tr>
            <td>{{ totalSubtasksText(task) }}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="row py-2 d-flex align-items-center">
      <div class="col">
        <button type="button" class="link-btn" @click="viewDetails = true">
          Details
          <i class="fa fa-angle-down ml-3"></i>
        </button>
      </div>
      <div class="col text-right">
        <button type="button" class="btn wfh-btn-primary position-relative"
                @click="pickUpTask(task.id)"
                :disabled="isLoading">
                            <span
                                class="spinner-border position-absolute"
                                role="status"
                                style="left: 16px;top: 10px;"
                                v-if="isLoading"
                            >
                                <span class="sr-only">Loading...</span>
                            </span>
          Pick Up Task
        </button>
      </div>
    </div>

    <transition name="fade">
      <OpenTaskDetailsModal
          v-if="viewDetails"
          :task="task"
          :actionText="'Pick Up Task'"
          @submit="pickUpTask(task.id)"
          @close="viewDetails = !viewDetails"
      />
    </transition>
  </section>
</template>

<script>
import Timeformatter from '../ActivityFeed/Timeformatter';
import OpenTaskDetailsModal from '../Misc/Modal/OpenTaskDetailsModal';

export default {
  components: { OpenTaskDetailsModal },
  props: ['task', 'isLoading'],

  data () {
    return {
      timeFormatter: Timeformatter,
      viewDetails: false,
    };
  },

  computed: {
    estimatedTaskCompletionDate () {
      return this.task.task_cost?.estimated_completion_date ?? 'N/A';
    },

    estimatedTaskHour () {
      return this.task.task_cost?.hour_estimation ?? 'N/A';
    },

    estimatedCost () {
      return this.task.task_cost?.cost_estimation ? `${this.task.task_cost.cost_currency} ${this.task.task_cost.cost_estimation}` : 'N/A';
    },
  },

  methods: {
    totalSubtasksText (task) {
      const total = task.total_subtasks;

      return `${total} task${total > 1 ? 's' : ''}`;
    },

    pickUpTask (taskId) {
      this.viewDetails = false;
      this.$emit('pickUpTask', taskId);
    },
  },
};
</script>

<style scoped lang="scss">

.task-title {
  color: #303030;
  font-family: Lato, serif;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 28px;
}

.task-description {
  color: #808fa4;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0.5px;
  line-height: 20px;
  white-space: pre-wrap;
  width: 100%;
  overflow: auto;
  max-height: 120px;
}

.task-company-name {
  color: #8997aa;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 22px;
  align-items: center;

  &:before {
    content: ' ';
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background-color: #2ecc71;
    margin-right: 8px;
  }
}

.task-creation-date {
  color: #8997aa;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 17px;
}

th {
  color: #808fa4;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 22px;
}

td {
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
}

.link-btn {
  display: flex;
  align-items: center;
  color: #0db4e6;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
  border: none;
  outline: none;
  background-color: transparent;
  padding: 0;

  .fas {
    color: #3593fe !important;
  }
}

.wfh-btn-primary {
  width: auto !important;
  padding: 0 60px !important;
}
</style>
